import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-trending-products',
    templateUrl: './trending-products.component.html',
    styleUrls: ['./trending-products.component.scss']
})
export class TrendingProductsComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    sectionTitle = [
        {
            title: "Premium Picks of the Week",
            paragraph: "Explore this week's most sought-after premium tiles, crafted for elegance and durability. From exquisite marble finishes to sleek, modern designs, our top selections bring sophistication to any space."
        }
    ]
    singleProductsBox = [
       {
    mainImg: 'assets/img/premium/wall.png',
    title: 'Designer Wall Tiles',
    newPrice: '₹ 200.00',
            oldPrice: '₹ 250.00',
    outOfStock: 'Out of Stock',
    paragraph: 'Stylish Designer tiles, ideal for adding character and charm to balcony and sitting area walls.',
    detailsLink: 'simple-product'
},
        {
            mainImg: 'assets/img/premium/garden.png',
            title: 'Outdoor Tiles',
            newPrice: '₹ 590.00',
            oldPrice: '₹ 710.00',
            sale: 'Sale!',
            outOfStock: '',
            detailsLink: 'simple-product'
        },
       
        {
            mainImg: 'assets/img/premium/trend1.png',
            title: 'Hexagonal Pattern Tiles',
            newPrice: '₹ 400.00',
            oldPrice: '₹ 580.00',
            outOfStock: '',
            detailsLink: 'simple-product'
        },
         {
            mainImg: 'assets/img/premium/rock.png',
            title: 'Rock Textutre Tiles',
            newPrice: '₹ 750',
            oldPrice: '₹ 1000',
            outOfStock: '',
            detailsLink: 'simple-product'
        },
         {
            mainImg: 'assets/img/premium/design.png',
            title: 'Textured Tiles',
            newPrice: '₹ 450',
            oldPrice: '₹ 550',
            outOfStock: '',
            detailsLink: 'simple-product'
        },
       
        {
            mainImg: 'assets/img/premium/bathroom.png',
            title: 'Designer WashBasin Tiles',
            newPrice: '₹ 400.00',
            oldPrice: '₹ 580.00',
            outOfStock: '',
            detailsLink: 'simple-product'
        }, {
            mainImg: 'assets/img/premium/trend2.png',
            title: 'Pattern Tiles',
            newPrice: '₹ 300.00',
            oldPrice: '₹ 400.00',
            outOfStock: '',
            detailsLink: 'simple-product'
        },
    ]
    

    productsSlidesOptions: OwlOptions = {
		loop: true,
		nav: false,
		dots: true,
		autoplayHoverPause: true,
		autoplay: true,
		autoplayTimeout: 4000,
		autoplaySpeed: 800,
		smartSpeed: 800,
		margin: 30,
		navText: [
			"<i class='bx bx-left-arrow-alt'></i>",
			"<i class='bx bx-right-arrow-alt'></i>"
		],
		responsive: {
			0: {
				items: 1
			},
			576: {
				items: 2
			},
			768: {
				items: 2
			},
			992: {
				items: 3
			},
			1200: {
				items: 3
			}
		}
    }

}
